export const keys =[['q','w','e','r','t','y','u','i','o','p'],
                    ['a','s','d','f','g','h','j','k','l', 'ç'],
                    ['ENTER','z','x','c','v','b','n','m','\u232b']
                   ]; 

